export const REQUEST_RESIDENTS_FETCH_AD = "REQUEST_RESIDENTS_FETCH_AD";
export const FETCH_RESIDENTS_AD_SUCCESS = "FETCH_RESIDENTS_AD_SUCCESS";
export const FETCH_RESIDENTS_AD_FAILURE = "FETCH_RESIDENTS_AD_FAILURE";

export const CLEAR_FETCH_RESIDENTS_AD_STATES =
  "CLEAR_FETCH_RESIDENTS_AD_STATES";
